<template>
  <div class="relative flex flex-col min-w-0 break-words w-full">
    <div class="rounded-t mb-0 pb-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h3 class="text-3xl text-blueGray-700 font-headline mt-4 mx-5">
            Research Compass Chats
          </h3>
        </div>
      </div>
    </div>
    <DataTable
      class=""
      :admin-prefix="adminPrefix"
      :api-prefix="apiPrefix"
      :singular-label="singularLabel"
      :plural-label="pluralLabel"
      :columns="columns"
      :actions="actions"
      :nested-level="0"
    />
    <right-side-modal ref="researchCompassDetailModal" :showing="false">
      <template #header>
        <h4 class="text-xl font-headline">Research Compass Detail</h4>
      </template>
      <template #body>
        <research-compass-detail-modal
          v-if="researchCompassDetail"
          :research-compass="researchCompassDetail"
        />
      </template>
    </right-side-modal>
  </div>
</template>
<script>
import DataTable from "./DataTable.vue";
import RightSideModal from "../Modals/RightSide.vue";
import ResearchCompassDetailModal from "../ResearchCompass/ResearchCompassDetailModal.vue";

export default {
  name: "ResearchCompasses",
  components: {
    DataTable,
    RightSideModal,
    ResearchCompassDetailModal,
  },
  data() {
    return {
      singularLabel: "research compass",
      pluralLabel: "research compass chats",
      adminPrefix: "research-compasses",
      apiPrefix: "research-compass",
      researchCmpassDetail: null,
      columns: {
        hashedId: {
          type: "formattedString",
          label: "ID",
          hidden: "yes",
          format(row) {
            const els = [];
            els.push(
              `<span class="text-xs uppercase font-mono text-nowrap">rc-${row.hashedId}</span>`,
            );
            return `
              <span class="text-nowrap">
                ${els.join("")}
              </span>
            `;
          },
          sort: {
            allow: false,
          },
          filter: {
            allow: true,
            matchType: "hashedId",
            prefix: "cr-",
          },
        },
        createdAt: {
          type: "absoluteDate",
          label: "Created At",
          sort: {
            allow: true,
            default: "desc",
          },
          filter: {
            allow: false,
            matchType: "dateRange",
            value: "",
            // config: https://chmln.github.io/flatpickr/options/
            config: {
              mode: "range",
              maxDate: "today",
            },
          },
        },
        collaborationSpaceOrPerson: {
          type: "formattedString",
          label: "Space Or Person",
          format(row) {
            const els = [];
            if (row.collaborationSpace?.hashedId) {
              els.push(`<span class="form-label">Space</span>`);
              els.push(
                `<span class="text-nowrap">${row.collaborationSpace?.name}</span>`,
              );
              els.push(
                `<button class="text-xs bg-tiara-300 px-2 py-1 ml-2 text-white rounded"><a href="/admin/collaboration-spaces/edit/${row.collaborationSpace.hashedId}" target="_blank"><i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square m-[2.5px]"></i></a></button>`,
              );
            } else if (row.person?.hashedId) {
              if (row.person.personType) {
                els.push(`<span class="form-label">Researcher</span>`);
              } else {
                els.push(`<span class="form-label">Public</span>`);
              }
              els.push(
                `<span class="text-nowrap">${row.person.firstName} ${row.person.lastName}</span>`,
              );
              if (row.person.profile) {
                els.push(
                  `<button class="text-xs bg-tiara-300 px-2 py-1 ml-2 text-white rounded"><a href="/admin/profiles/edit/${row.person.profile.hashedId}" target="_blank"><i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square m-[2.5px]"></i></a></button>`,
                );
              }
            } else {
              els.push(`<span class="form-label">Public</span>`);
              els.push(`<span class="text-nowrap">Anonymous</span>`);
            }
            return `
              <span class="text-nowrap">
                ${els.join("")}
              </span>
            `;
          },
          sort: {
            allow: true,
            default: null,
          },
          filter: {
            allow: true,
            matchType: "wildcard",
            value: "",
          },
        },
        titleAndQuestions: {
          type: "formattedString",
          label: "Title",
          format(row) {
            const els = [];
            els.push(
              `<p class="max-w-[500px] overflow-ellipsis text-nowrap overflow-hidden"><strong>${row.title}</strong></p>`,
            );
            if (row.questions?.length > 0) {
              els.push(`<ul class="list-disc">`);
              row.questions.forEach((question) => {
                els.push(
                  `<p class="max-w-[500px] overflow-ellipsis text-nowrap overflow-hidden">&bull; ${question.question}</p>`,
                );
              });
              els.push(`</ul>`);
            }
            return `
              <span class="text-nowrap">
                ${els.join("")}
              </span>
            `;
          },
          hidden: "never",
          sort: {
            allow: true,
            default: null,
          },
          filter: {
            allow: true,
            matchType: "wildcard",
            value: "",
          },
        },
      },
      actions: {
        update: {
          allow: false,
        },
        delete: {
          allow: false,
        },
        menuItems: [
          {
            label: "View Details",
            qualifier() {
              return true;
            },
            action(event, row) {
              const self = this;
              return [
                "executeFunc",
                function _() {
                  self.vm.loadDetail(row);
                },
              ];
            },
            vm: this,
          },
        ],
      },
    };
  },
  methods: {
    loadDetail(row) {
      this.researchCompassDetail = row;
      this.toggleResearchCompassDetailModal();
    },
    toggleResearchCompassDetailModal() {
      this.$refs.researchCompassDetailModal.toggleModal();
    },
  },
};
</script>
